import { PureLightTheme } from "../../../../../styles/theme";

export const CardStyle = {
    padding: "24px 20px 20px 20px", 
    width: "100%",
    marginBottom: 5,
    overflowX: "auto",
    [PureLightTheme.breakpoints.down("md")]: {
        padding: "24px 20px 20px 20px", 
        mb: 2,
    },
    [PureLightTheme.breakpoints.down('sm')]: {
        width: "calc(100% + 24px)",
        margin: "0px -12px 16px -12px",
    },
}
